import { Component, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseComponent } from '@app/modules/case/components/case-base/case.component';
import { CaseService } from '@app/core/services/case.service';

@Component({
    templateUrl: './case-detailed-summary.component.html',
    styleUrls: ['./case-detailed-summary.component.scss']
})
export class CaseDetailedSummaryComponent extends CaseComponent
                                          implements OnInit {

    constructor(protected componentServiceBundle: ComponentServiceBundle, protected caseService: CaseService) {
        super(componentServiceBundle, caseService);
        this._idPrefix = 'case_detailed_summary.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }
}
